import { useEffect, useState } from "react";
import { Github } from "lucide-react";
import { siteGitHubRepository, siteGitHubUrl } from "@/config/site";
import { useTranslation } from "@/common/providers/i18n-provider";
import { formatNumberLocalized } from "@/lib/format";

export function GitHubStarButton() {
  const { locale } = useTranslation();
  const [stars, setStars] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`https://api.github.com/repos/${siteGitHubRepository}`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { stargazers_count?: number } | null) => {
        if (!cancelled && typeof data?.stargazers_count === "number") {
          setStars(data.stargazers_count);
        }
      })
      .catch(() => {
        /* count is optional — button still works without it */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <a
      href={siteGitHubUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Star ${siteGitHubRepository} on GitHub`}
      className="inline-flex items-stretch overflow-hidden rounded-md border border-slate-300 dark:border-slate-600 text-sm font-semibold leading-none shadow-sm"
    >
      <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-800 dark:text-slate-100 transition-colors">
        <Github className="w-4 h-4" aria-hidden="true" />
        Star
      </span>
      {stars !== null && (
        <span className="inline-flex items-center px-3 py-1.5 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 border-l border-slate-300 dark:border-slate-600">
          {formatNumberLocalized(stars, locale)}
        </span>
      )}
    </a>
  );
}
